/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAndCloseAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAndCloseAction({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/SaveAndCloseAction"
  
}) {
let editorIsDirtyValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'isDirty',
})
let editorSavingValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'saving',
})
let aggregateData = fromHelpers.disabled(editorIsDirtyValueData, editorSavingValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={onClick}
 data="editor.isDirty"
 data="editor.saving"
 aggregate="./helpers.js disabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save & close"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}